import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  ErasmusApplicationEdit,
  ErasmusApplicationOrderPage,
  ErasmusApplicationPage,
  ErasmusConsortiumEdit,
  ErasmusConsortiumPage,
  ErasmusChallengesEdit,
  ErasmusChallengesPage,
  ErasmusDashboard,
  ErasmusMobilitiesPage,
  ErasmusQuestionnaire,
  ErasmusSubjectsEdit,
  ErasmusSubjectsPage,
  ErasmusUniversitiesEdit,
  ErasmusUniversitiesPage,
} from '../pages/CMSPages/index';
import React from 'react';

const ErasmusRoutes = () => (
  <>
    <Route
      path={`${routes.cmsErasmusApplication}`}
      element={
        <CMSWrapper permissions={['erasmus-applications.index']}>
          <ErasmusApplicationPage uniqueTableId="erasmus-applications-active-v2" />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusApplicationCreate}`}
      element={
        <CMSWrapper permissions={['erasmus-applications.store']}>
          <ErasmusApplicationEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusApplicationEdit}/:id`}
      element={
        <CMSWrapper permissions={['erasmus-applications.update']}>
          <ErasmusApplicationEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusApplicationOrder}`}
      element={
        <CMSWrapper permissions={['erasmus-applications.update']}>
          <ErasmusApplicationOrderPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusApplicationArchive}`}
      element={
        <CMSWrapper permissions={['erasmus-applications.index']}>
          <ErasmusApplicationPage
            mode={'archive'}
            uniqueTableId="erasmus-applications-archive-v2"
          />
        </CMSWrapper>
      }
    />
    {/* Universities */}
    <Route
      path={`${routes.cmsErasmusUniversity}`}
      element={
        <CMSWrapper permissions={['erasmus-universities.index']}>
          <ErasmusUniversitiesPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusUniversityCreate}`}
      element={
        //TODO: make permissions for uni and make edit page for uni
        <CMSWrapper permissions={['erasmus-universities.store']}>
          <ErasmusUniversitiesEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusUniversityEdit}/:id`}
      element={
        //detto
        <CMSWrapper permissions={['erasmus-universities.update']}>
          <ErasmusUniversitiesEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    {/* Consortiums */}
    <Route
      path={`${routes.cmsErasmusConsortium}`}
      element={
        <CMSWrapper permissions={['erasmus-consortiums.index']}>
          <ErasmusConsortiumPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusConsortiumCreate}`}
      element={
        //TODO: make permissions
        <CMSWrapper permissions={['erasmus-consortiums.store']}>
          <ErasmusConsortiumEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusConsortiumEdit}/:id`}
      element={
        <CMSWrapper permissions={['erasmus-consortiums.update']}>
          <ErasmusConsortiumEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    {/* Challenges */}
    <Route
      path={`${routes.cmsErasmusChallenges}`}
      element={
        <CMSWrapper permissions={['erasmus-challenges.index']}>
          <ErasmusChallengesPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusChallengesCreate}`}
      element={
        <CMSWrapper permissions={['erasmus-challenges.store']}>
          <ErasmusChallengesEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusChallengesEdit}/:id`}
      element={
        <CMSWrapper permissions={['erasmus-challenges.update']}>
          <ErasmusChallengesEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    {/* Subjects */}
    <Route
      path={`${routes.cmsErasmusSubjects}`}
      element={
        // TODO: make permissions for subjects
        <CMSWrapper permissions={['erasmus-subjects.index']}>
          <ErasmusSubjectsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusSubjectsCreate}`}
      element={
        //TODO: make permissions
        <CMSWrapper permissions={['erasmus-subjects.store']}>
          <ErasmusSubjectsEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusSubjectsEdit}/:id`}
      element={
        <CMSWrapper permissions={['erasmus-subjects.update']}>
          <ErasmusSubjectsEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    {/* Mobilities */}
    <Route
      path={`${routes.cmsErasmusMobility}`}
      element={
        // TODO: make permissions for mobility
        <CMSWrapper permissions={['erasmus-mobilities.index']}>
          <ErasmusMobilitiesPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusMobilityQuestionnaireCreate}/:mobility_id`}
      element={
        //TODO: make permissions
        <CMSWrapper permissions={['erasmus-mobilities.store']}>
          <ErasmusQuestionnaire mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsErasmusMobilityQuestionnaireEdit}/:id`}
      element={
        <CMSWrapper permissions={['erasmus-mobilities.update']}>
          <ErasmusQuestionnaire mode={'edit'} />
        </CMSWrapper>
      }
    />
    {/* Dashboard */}
    <Route
      path={`${routes.cmsErasmusDashboard}`}
      element={
        // TODO: make permissions for mobility
        <CMSWrapper permissions={['erasmus-applications.index']}>
          <ErasmusDashboard />
        </CMSWrapper>
      }
    />
  </>
);

export default ErasmusRoutes;
